import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressCloudDataApiIndexIndexServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/cloud-data',
        destPath: '',
      },
    ],
    'code._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/v1/connector',
        destPath: '/v1/connector',
      },
      {
        srcPath: '/_api/data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/v1/connector',
        destPath: '/v1/connector',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
    ],
    'cloud-data.wix-code.com': [
      {
        srcPath: '',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
      {
        srcPath: '/_api/data',
        destPath: '',
      },
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
      {
        srcPath: '/_api/data',
        destPath: '',
      },
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wix-data/v1/collections',
        destPath: '/v1/wix-data/collections',
      },
      {
        srcPath: '/wix-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/wix-data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/wix-data/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/wix-data/v1/bulk',
        destPath: '/v1/bulk',
      },
      {
        srcPath: '/wix-data/v1/external-databases',
        destPath: '/v1/external-databases',
      },
      {
        srcPath: '/wix-data/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/data/v2/bulk/items',
        destPath: '/v2/bulk/items',
      },
      {
        srcPath: '/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
    ],
    'www.wixgateway.com': [
      {
        srcPath: '/wix-data/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/wix-data/v1/bulk',
        destPath: '/v1/bulk',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_data_indexes';

/**
 * Creates an index for a data collection.
 *
 * The index can't be used immediately, as the process of generating the index takes time.
 * You can check whether an index is ready by calling List Indexes.
 *
 * Note that when an index fails to create, the failed index still occupies a slot.
 * To remove the failed index and free up the slot for a new index, call Drop Index.
 */
export function createIndex(payload: object): RequestOptionsFactory<any> {
  function __createIndex({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.index',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.cloud.data.api.index.IndexService.CreateIndex',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: '/v2/indexes',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createIndex;
}

/**
 * Removes an index from a data collection.
 *
 * The process of dropping an index from a collection takes time.
 * You can check whether an index has been dropped by calling List Indexes.
 */
export function dropIndex(payload: object): RequestOptionsFactory<any> {
  function __dropIndex({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.index',
      method: 'DELETE' as any,
      methodFqn: 'com.wixpress.cloud.data.api.index.IndexService.DropIndex',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: '/v2/indexes',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __dropIndex;
}

/**
 * Lists all indexes defined for a data collection.
 *
 * When an index's status is `ACTIVE`, it is ready to use.
 * While it is still being created, its status is `BUILDING`.
 *
 * When an index's status is `DROPPED`, it has been dropped successfully.
 * While it is still in the process of being removed, its status is `DROPPING`.
 */
export function listIndexes(payload: object): RequestOptionsFactory<any> {
  function __listIndexes({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.index',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.cloud.data.api.index.IndexService.ListIndexes',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: '/v2/indexes',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listIndexes;
}

/** Lists available indexes limits */
export function listAvailableIndexes(
  payload: object
): RequestOptionsFactory<any> {
  function __listAvailableIndexes({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.index',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.index.IndexService.ListAvailableIndexes',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: '/v2/indexes/available',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listAvailableIndexes;
}
